import React from 'react';
import moment from 'moment';
import DataCell from './DataCell';

const cell = {
    textAlign: 'right'
};

const DateDataCell = ({
    rowIndex,
    data,
    accessor,
    scrollPxH,
    scrollPxV,
    isSticky,
    isHighlighted,
    style,
    onHover,
    dateFormat,
    rowHeight,
    deleteRowSelected,
    highlightedIdx,
    setHighlightedIdx,
    highlightOnClick = false
}) => {
    return (
        <DataCell
            rowIndex={rowIndex}
            scrollPxH={scrollPxH}
            scrollPxV={scrollPxV}
            id={`${accessor}${rowIndex}`}
            style={{ height: rowHeight, ...cell, ...style }}
            isSticky={isSticky}
            isHighlighted={isHighlighted}
            deleteRowSelected={deleteRowSelected}
            onHover={onHover}
            highlightedIdx={highlightedIdx}
            setHighlightedIdx={setHighlightedIdx}
            highlightOnClick={highlightOnClick}
        >
            {moment(data[accessor]).isValid()
                ? moment(data[accessor]).format(dateFormat)
                : ''}
        </DataCell>
    );
};

export default DateDataCell;
